import { RfbStatus } from '@/utils/Enumerations.js'

export const MAX_BID_DISTANCE = 250
export const MAX_BID_RATE = 5_000
export const MAX_BID_HARVEST_VOLUME = 50_000

export const costComponentTotal = (costComponents) => Math.round(costComponents.reduce((total, c) => total + c.rate, 0) * 100) / 100

export const rateDivergesFromCosts = (product) => product.costComponents.length > 0 && costComponentTotal(product.costComponents) !== product.deliveredRate

export const isBidOpen = (bid) => (bid.outcome === null || bid.outcome === undefined) &&
  bid.rfbStatus !== RfbStatus.Withdrawn.value &&
  bid.rfbStatus !== RfbStatus.Pass.value

export class Bid {
  constructor (bidResponse) {
    this.bidId = bidResponse.bidId
    this.externalId = bidResponse.externalId
    this.tractId = bidResponse.tractId
    this.name = bidResponse.name
    this.spot = bidResponse.spot
    this.destinationAccountId = bidResponse.destinationAccountId
    this.distance = bidResponse.distance
    this.supplierAccountId = bidResponse.supplierAccountId
    this.bidDate = bidResponse.bidDate
    this.bidExpiration = bidResponse.bidExpiration
    this.harvestStartDate = bidResponse.harvestStartDate
    this.harvestEndDate = bidResponse.harvestEndDate
    this.rfbStatus = bidResponse.rfbStatus
    this.outcome = bidResponse.outcome
    this.reason = bidResponse.reason
    this.timberCategoryId = bidResponse.timberCategoryId
    this.conversionId = bidResponse.conversionId
    this.landownerTypeId = bidResponse.landownerTypeId
    this.products = (bidResponse.products ?? []).map(p => ({
      bidProductId: p.bidProductId,
      productId: p.productId,
      harvestVolume: p.harvestVolume,
      deliveredRate: p.deliveredRate,
      status: p.status,
      costComponents: p.costComponents ?? []
    }))
  }
}
